import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const PassagePrep = ({ value, onChange, label = 'Passage Prep', passSelectedDoor }) => {
    const [selectedPassagePrep, setSelectedPassagePrep] = useState(value || "");

    useEffect(() => {
        if (passSelectedDoor) { }
    }, [passSelectedDoor]); // Trigger effect whenever passSelectedDoor changes

    const handlePassagePrepChange = (e) => {
        const newValue = e.target.value;
        setSelectedPassagePrep(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="PassagePrep">{label}</label>
            <select style={{ display: "none" }}
                id="PassagePrep"
                value={selectedPassagePrep}
                onChange={handlePassagePrepChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value="None">{selectedPassagePrep === "None" ? "None ✔" : "None"}</option>
              <option value="YesActiveDoor">{selectedPassagePrep === "YesActiveDoor" ? "Yes - Active Door ✔" : "Yes - Active Door"}</option>
              {passSelectedDoor && [5, 6, 7, 8].includes(passSelectedDoor.id) && (
              <option value="YesBothDoors">{selectedPassagePrep === "YesBothDoors" ? "Yes - Both Doors ✔" : "Yes - Both Doors"}</option>
              )}
            </select>
        </div>
    );
};

export default PassagePrep;
